import log from 'loglevel';
import { router } from '../../services'

const validateSerialNumber = async (serialNumber, credentials) => {
  const type = 'ValidationAsset';
  const serialNumbersPayload = {
    serialNumber,
    type: 'HULA',
  }
  
  try {
    const validateAssets = await router(type, serialNumbersPayload, credentials);
    return validateAssets;
  } catch (err) {
    log.error(err);
    return err;
  }
};

export default validateSerialNumber;